<h1>{{'RESULTS.SECTIONS.PROJECT_FLOW_DIAGRAM' | anessaTranslation: trigger}}</h1>
<p class="addedmargin" ></p>
<h3 *ngIf="!this.results" class="center">{{'RESULTS.ERRORS.NO_RESULTS_PLEASE_SIMULATE' | anessaTranslation: trigger}}</h3>
<app-flow-diagram-creator
  [project]="project"
  [precision]="precision"
  *ngIf="project && results"
  [results]="results"
  [updateGraphSignal]="reloadFlowEmitter"
></app-flow-diagram-creator>
